/**
 * Sync storefront country (flag / currency / market) to the visitor IP.
 * Uses Shopify browsing_context_suggestions, then ?country=XX (reliable cookie path).
 */
(function () {
  try {
    if (window.__hestiaGeoRan) return;
    window.__hestiaGeoRan = true;

    var STORAGE_KEY = 'hestia:geo-synced';
    var STORAGE_COUNTRY = 'hestia:geo-country';

    function currentCountry() {
      var c =
        (window.Shopify && Shopify.country && String(Shopify.country)) ||
        (document.querySelector('localization-form [name="country_code"], form[action*="/localization"] [name="country_code"]') || {})
          .value ||
        '';
      return String(c).toLowerCase();
    }

    function updateFlagUi(iso) {
      if (!iso) return;
      var code = String(iso).toLowerCase();
      var upper = code.toUpperCase();
      document.querySelectorAll('.localization-current img, .cart-country-banner__flag img').forEach(function (img) {
        var w = img.getAttribute('width') || '18';
        var src = '//cdn.shopify.com/static/images/flags/' + code + '.svg?width=' + w;
        img.setAttribute('src', src);
        img.setAttribute('srcset', src + ' ' + w + 'w');
        img.setAttribute('alt', upper);
      });
      document.querySelectorAll('.localization-iso').forEach(function (el) {
        el.textContent = upper;
      });
      document.querySelectorAll('localization-form [name="country_code"], form[action*="/localization"] [name="country_code"]').forEach(
        function (input) {
          input.value = upper;
        }
      );
      if (window.Shopify) Shopify.country = upper;
    }

    function redirectToCountry(iso) {
      var code = String(iso).toUpperCase();
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
        sessionStorage.setItem(STORAGE_COUNTRY, code.toLowerCase());
      } catch (e) {}

      var url = new URL(window.location.href);
      if ((url.searchParams.get('country') || '').toUpperCase() === code) {
        updateFlagUi(code);
        return;
      }
      url.searchParams.set('country', code);
      window.location.replace(url.toString());
    }

    var current = currentCountry();
    try {
      var synced = sessionStorage.getItem(STORAGE_KEY);
      var stored = (sessionStorage.getItem(STORAGE_COUNTRY) || '').toLowerCase();
      if (synced && stored && current && stored === current) return;
      if (synced && stored && current && stored !== current) {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {}

    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !data.detected_values || !data.detected_values.country) return;
        var detected = (data.detected_values.country.handle || data.detected_values.country.code || '')
          .toString()
          .toLowerCase();
        if (!detected) return;

        current = currentCountry();
        if (current === detected) {
          updateFlagUi(detected);
          try {
            sessionStorage.setItem(STORAGE_KEY, '1');
            sessionStorage.setItem(STORAGE_COUNTRY, detected);
          } catch (e) {}
          return;
        }

        updateFlagUi(detected);
        redirectToCountry(detected);
      })
      .catch(function () {});
  } catch (e) {}
})();
